import { Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import store from "@/store";
import { MIRA_PERIOD_ROLLING_12 } from "@/data/models/Mira";
import { MIRA_BASELINE_PREVIOUS, MiraBaseline } from "@/utils/MiraBaseline";

const name = "miraPeriod";

if (store.state[name]) {
  store.unregisterModule(name);
}

/**
 * The period chosen on the Mira landing page or on any Mira screen, shared by all of them (Hans,
 * #2610137: the landing page gets the period and comparison icons the screens have), so a screen opens
 * on the period picked on the landing page and the other way round. A page whose documents lack the
 * stored period shows its first period without overwriting it (`effectivePeriod`), so the choice
 * survives a visit to a screen that has no such year.
 *
 * Not persisted, like the comparison mode and the timeline grain: it resets to the last 12 months on a
 * reload.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class MiraPeriodVuexModule extends VuexModule {
  period: string = MIRA_PERIOD_ROLLING_12;

  /**
   * What the changes compare with (Hans, #2610137, 2026-11-02): "Vorherige Periode" or "Letzte 12 Monate",
   * chosen in the calendar beside the period and shared like it. A period that does not offer it compares
   * with "Vorherige Periode" without overwriting the choice.
   */
  baseline: MiraBaseline = MIRA_BASELINE_PREVIOUS;

  @Mutation
  setPeriod(period: string) {
    this.period = period;
  }

  @Mutation
  setBaseline(baseline: MiraBaseline) {
    this.baseline = baseline;
  }
}

export const MiraPeriodModule = getModule(MiraPeriodVuexModule);
